var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorConsultation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4556 28.2905H22.026V25.1938H17.5523V17.9663C17.5523 14.7351 14.9329 12.1157 11.7017 12.1157H10.2391H8.77636C5.54511 12.1157 2.92578 14.7351 2.92578 17.9663V19.5146H14.4557V28.2905H14.4556Z",
    fill: "#D83F87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4024 31.0444H14.4551V35.5182H20.4771V43.6603H24.9508V32.5928C24.9508 31.739 24.2561 31.0444 23.4024 31.0444Z",
    fill: "#D83F87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7793 28.5179C26.4781 29.0936 27.7046 30.7021 27.7046 32.5929V33.0501H30.4585V30.2962H33.2124V33.0501H35.9663V35.804H33.2124V38.5579H30.4585V35.804H27.7046V43.6603H46.9998V25.1938H24.7793V28.5179Z",
    fill: "#D83F87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2961 22.4399H44.0753V17.9663C44.0753 14.7351 41.4559 12.1157 38.2247 12.1157H36.7621H35.2994C32.5426 12.1157 30.2326 14.0229 29.6133 16.5894H34.5647L35.2961 22.4399Z",
    fill: "#D83F87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.761 12.1157C39.1844 12.1157 41.149 10.1511 41.149 7.7277C41.149 5.30429 39.1844 3.33972 36.761 3.33972C34.3376 3.33972 32.373 5.30429 32.373 7.7277C32.373 10.1511 34.3376 12.1157 36.761 12.1157Z",
    fill: "#D83F87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2376 12.1157C12.661 12.1157 14.6256 10.1511 14.6256 7.7277C14.6256 5.30429 12.661 3.33972 10.2376 3.33972C7.81418 3.33972 5.84961 5.30429 5.84961 7.7277C5.84961 10.1511 7.81418 12.1157 10.2376 12.1157Z",
    fill: "#D83F87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5209 22.4399L32.1338 19.3433H25.1582L25.5452 22.4399H32.5209Z",
    fill: "#D83F87"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7013 22.2686H0V43.6603H2.75391V35.5181H8.94735V43.6603H11.7013V22.2686Z",
    fill: "#D83F87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorConsultation1);
export default __webpack_public_path__ + "static/media/doctor-consultation 1.4a70fae58665c18cb359dde31044185d.svg";
export { ForwardRef as ReactComponent };